import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import URL from '../../../constants/url';
import avatarMen from '../../../images/common/i_avatar_men.svg'
import style from './ContactlessSetting.module.css';
import TimeZoneSelectBox from '../../../components/box/TimeZoneSelectBox';
import SwitchBox from '../../../components/box/SwitchBox';
import Modal from '../../../components/comm/Modal';


const ContactlessSetting = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const [isOpen, setIsOpen] = useState(false);
    const [pendingPushToggle, setPendingPushToggle] = useState(false);
    const [pushAlarm, setPushAlarm] = useState(true);
    const [notificationPermission, setNotificationPermission] = useState(null);
    const [isCheckingPermission, setIsCheckingPermission] = useState(false);

    // user 정보 
    const { user } = location.state || {};

    console.log("user", user )

    // 웹뷰 체크 함수
    const isWebView = () => {
        return window.ReactNativeWebView !== undefined;
    };

    // 네이티브로부터 메시지 수신
    useEffect(() => {
        const handleNativeMessage = (event) => {
            try {
                const message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                console.log('네이티브 메시지 수신:', message);

                if (message.type === 'NOTIFICATION_PERMISSION_RESULT') {
                    setNotificationPermission(message.granted);
                    setIsCheckingPermission(false);
                }
            } catch (error) {
                console.error('메시지 파싱 오류:', error);
            }
        };

        window.addEventListener('message', handleNativeMessage);
        return () => window.removeEventListener('message', handleNativeMessage);
    }, []);

    // 컴포넌트 마운트 시 권한 체크
    useEffect(() => {
        if (isWebView()) {
            checkNotificationPermission();
        }
    }, []);

    // 알림 권한 체크
    const checkNotificationPermission = () => {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: 'CHECK_NOTIFICATION_PERMISSION' })
            );
        }
    };

    // 알림 권한 요청/설정 열기
    const getNativAlrmPermission = () => {
        setIsCheckingPermission(true);

        if (window.ReactNativeWebView) {
            if (notificationPermission === false) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: 'OPEN_APP_SETTINGS' })
                );
            } else {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: 'REQUEST_NOTIFICATION_PERMISSION' })
                );
            }
        }
    };

    const handlePushToggle = (value) => {
        // 켜려고 할 때 네이티브 권한이 없는 경우
        if (value === true && notificationPermission === false) {
            alert('To turn on push notifications, you must first allow app notifications in your phone settings. Go to the settings screen.');
            // alert("푸시 알림을 켜려면 먼저 휴대폰 설정에서 앱 알림을 허용해야 합니다. 설정 화면으로 이동합니다.");
            getNativAlrmPermission();
            return;
        }

        if (!value) {
            setPendingPushToggle(value);
            setIsOpen(true);
        } else {
            setPushAlarm(value);
        }
    };

    const confirmTurnOffPush = () => {
        setPushAlarm(pendingPushToggle);
        setIsOpen(false);
    };

    const cancelTurnOffPush = () => {
        setPendingPushToggle(false);
        setIsOpen(false);
    };

    return (
        <>
            <HeadSub title="Setting" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['profile-box']}>
                        <div className={style['avatar-box']}>
                            <div className={style['avatar-img']}>
                                <object data={avatarMen} alt="" aria-hidden='true'/>
                            </div>
                            <p>{user?.usrNm}</p>
                        </div>
                        <button className={style['edit-btn']} onClick={() => { navigate(URL.CONTACTLESS_EDIT)  }}>
                            <span>My Info</span>
                        </button>
                    </div>

                    <div className={style['contents-box']}>
                        <ul>
                            <li>
                                <p>Time Zone</p>
                                <TimeZoneSelectBox />
                            </li>
                            <li>
                                <button className={style['hosLink-btn']} onClick={() => { navigate(URL.HOSPITAL_LINKAGE) }}>
                                    <span>Hospital</span>
                                </button>
                            </li>
                            <li>
                                <p>Notification</p>
                                <SwitchBox toggles={pushAlarm} status={handlePushToggle} />
                            </li>
                        </ul>

                        {isWebView() && !notificationPermission && (
                            <div className={style['bot-box']}>
                                <div className={style['inner-box']}>
                                    <div className={style['head']}>
                                        <p>Notifications for this app are currently turned off. </p>
                                        <button
                                            className='btn'
                                            data-btn-size='sm'
                                            data-btn-type="fill-main"
                                            onClick={getNativAlrmPermission}
                                            disabled={isCheckingPermission}
                                        >
                                            <span>
                                                {isCheckingPermission ? 'Checking...' : 'Go to Settings'}
                                            </span>
                                        </button>
                                    </div>
                                    <div className={style['bot']}>
                                        <span>Please enable notifications to view them on your lock screen.</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>

            <Modal isOpen={isOpen} setIsOpen={setIsOpen} >
                <div className='modal-box' data-type="a">
                    <div className='modal-top-box'>
                        <div className='title-box'>
                            <p> Would you like to turn off <br />push notifications?</p>
                        </div>
                        <div className='sub-box'>
                            <span>
                                If you turn off push notifications,<br />
                                you won't receive alerts on your phone,<br />
                                and notifications will only be available<br />
                                in the in-app Notification Center.
                            </span>
                        </div>
                    </div>

                    <div className="modal-bottom-box">
                        <div className='btn-layout'>
                            <button className="btn" data-btn-type="fill-gray" data-btn-size="md" onClick={cancelTurnOffPush}>
                                <span>Cancel</span>
                            </button>
                            <button className="btn" data-btn-type="fill-main" data-btn-size="md" onClick={confirmTurnOffPush}>
                                <span>Turn Off</span>
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ContactlessSetting;